import React from 'react'
import {FlexContainer as Container, Title} from '../../styled'
import { connect } from 'react-redux'

const NoMatch = (props) => (
    <Container  centerColumn fullSize>
        <Title>{props.t.notFound}</Title>
        <Title fontSize='5rem'>404</Title>
    </Container>
)

const mapStateToProps = state => ({
    t: state.i18nState.translations[state.i18nState.lang]["NotFound"]
})

export default connect(mapStateToProps)(NoMatch)